<div class="main">
  <!-- 工程分类明细 -->
  <div class="classify">
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">
      {{ 'TaskAssignment.EngineeringCategoryDetails' | translate }}
    </h4>
    <div class="classify-body">
      <ng-container *ngFor="let type of civlOrElectroInfo">
        <div *ngIf="projectItemInfo[type.value]" class="classify-left">
          <nz-table #middleTable nzSize="small" [nzShowPagination]="false"
            [nzPageSize]="projectItemInfo[type.value].length" [nzScroll]="{ y: '270px' }"
            [nzData]="projectItemInfo[type.value]">
            <thead>
              <tr>
                <th scope="col">{{ type.text }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of middleTable.data">
                <td>
                  <label nz-checkbox [nzDisabled]='taskAssignDisabled' [ngModel]="data.check"
                    (ngModelChange)="nzSendOrderRadioChange(data.middleType,'projectItemInfo',type.value)">
                    {{ data.middleType }}
                  </label>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </ng-container>
      <div style="clear:both;"></div>
    </div>
  </div>
  <!-- 派单厂务工程师:如果单据signStep>=5,即单据到厂商标单制定 ,则不能再重新指派厂务工程师 -->
  <div class="send-order">
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'TaskAssignment.DispatchFactoryEngineer' |
      translate }}</h4>
    <div class="sendorder-content">
      <nz-table class="sendorder-table" #sendOrderDataTable nzSize="small" [nzShowPagination]="false"
        [nzPageSize]="sendOrderData.length" [nzScroll]="{ y: '240px' }" [nzData]="sendOrderData">
        <thead>
          <tr>
            <th scope="col" nzWidth="10%">{{ 'Common.No' | translate }}</th>
            <th scope="col">{{ 'TaskAssignment.EngineerNameEmplid' | translate }}</th>
            <th scope="col">{{ 'TaskAssignment.BudgetEstimateToBeReviewed' | translate }}</th>
            <th scope="col">{{ 'TaskAssignment.BidToBeReviewed' | translate }}</th>
            <th scope="col">{{ 'TaskAssignment.Select' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of sendOrderDataTable.data;let i=index">
            <td>{{ i + 1 }}</td>
            <td>{{ data.assignName }}&nbsp;&nbsp;{{ data.assignEmplid }}</td>
            <td>{{ data.waitEstimateForm }}</td>
            <td>{{ data.waitBidForm }}</td>
            <td>
              <nz-radio-group [(ngModel)]="sendOrderChecked" nzName="assignRadiogroup"
                (ngModelChange)="nzSendOrderRadioChange($event,'sendOrderData')">
                <label nz-radio [nzValue]="data.assignEmplid" [nzDisabled]='taskAssignDisabled && engineerTaskAssignEdictStatus'></label>
              </nz-radio-group>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
  <!-- 选择厂商:如果单据signStep>=6,即单据到 预约厂商&概算--厂务概算制定 ,则不能再重新指派厂务工程师和厂商 -->
  <div class="facturer">
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'TaskAssignment.SelectVendor' | translate }}</h4>
    <div class="facturer-body">
      <ng-container *ngFor="let type of civlOrElectroInfo">
        <div>
          <em nz-icon nzType="plus-circle" nzTheme="outline"
            (click)="activeTable[type.value] = !activeTable[type.value]"></em>
          <span>{{ type.text }}{{ 'TaskAssignment.Vendor' | translate }}</span>
        </div>
        <div class="facturer-content" *ngIf="activeTable[type.value]">
          <nz-table class="facturerTable" #dataTable nzSize="small" [nzShowPagination]="false" [nzPageSize]="50"
            [nzScroll]="{ y: '230px' }" [nzData]="facturerData[type.value]">
            <thead>
              <tr>
                <ng-container *ngFor="let title of tableTitle">
                  <th scope="col">{{ title.text | translate }}</th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of dataTable.data;let i = index">
                <ng-container *ngIf="data['cicivlOrElectro'] === type.text">
                  <td>{{ i+1 }}</td>
                  <td>{{ data.vendorCode }}</td>
                  <td>{{ data.facturer }}</td>
                  <td>{{ data.technical }}</td>
                  <td>{{ data.contact }}</td>
                  <td>{{ data.tel }}</td>
                  <td nzBreakWord>{{ data.email }}</td>
                  <td>{{ data.issuedBid }}/{{ data.issuedTotal }}/{{ data.issuedBidPer }}</td>
                  <td>{{ data.issuedBidOverTime }}/{{ data.issuedBidOverTimeTotal }}/{{ data.issuedBidOverTimePer }}
                  </td>
                  <td>{{ data.notCooperateBids }}/{{ data.notCooperateBidsTotal }}/{{ data.notCooperateBidsPer }}</td>
                  <td>{{ data.waitBidNumbers }}</td>
                  <td>
                    <nz-radio-group [(ngModel)]="facturerDataCheck[type.value]" nzName="radiogroup"
                      (ngModelChange)="nzSendOrderRadioChange($event,'facturerData',type.value)">
                      <label nz-radio [nzValue]="data.vendorCode"
                        [nzDisabled]='taskAssignDisabled && vendorTaskAssignEdictStatus'></label>
                    </nz-radio-group>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </ng-container>
    </div>
  </div>
</div>